module.exports = __webpack_public_path__ + "img/6.ec2c9e00.jpg";